export function htmlDataTypeToHowlerFormat(htmlDataType: string): string {
    return htmlDataType.replace(/^audio\//i, "").replace(/^video\//, "")
}